(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    function syncCartUpsell(cart) {
    var productIds = ((cart && cart.items) || []).map(function (item) {
      return String(item.product_id);
    });

    document.querySelectorAll('[data-cart-upsell]').forEach(function (block) {
      var remaining = 0;

      block.querySelectorAll('[data-upsell-item]').forEach(function (item) {
        var isInCart = productIds.indexOf(item.getAttribute('data-product-id')) !== -1;
        item.classList.toggle('is-hidden', isInCart);
        if (!isInCart) remaining += 1;
      });

      block.hidden = !cart || cart.item_count === 0 || remaining === 0;
    });
  }

  function fetchCartForUpsell() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      })
      .then(syncCartUpsell);
  }

  document.addEventListener('cart:updated', function (event) {
    syncCartUpsell(event.detail);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-upsell-add]');
    if (!button || button.disabled) return;

    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalLabel = button.getAttribute('aria-label') || 'Add to cart';
    button.disabled = true;
    button.setAttribute('aria-label', 'Adding to cart');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add product');
        return response.json();
      })
      .then(function () {
        button.disabled = false;
        button.setAttribute('aria-label', originalLabel);

        if (typeof window.refreshCartDrawer === 'function') {
          window.refreshCartDrawer();
          return;
        }

        fetchCartForUpsell();
      })
      .catch(function () {
        button.disabled = false;
        button.setAttribute('aria-label', 'Could not add to cart. Try again');
      });
  });

  var cartItems = document.querySelector('.cart-items');
  if (cartItems && window.MutationObserver) {
    var cartUpsellRefreshTimer;
    new MutationObserver(function () {
      window.clearTimeout(cartUpsellRefreshTimer);
      cartUpsellRefreshTimer = window.setTimeout(fetchCartForUpsell, 50);
    }).observe(cartItems, { childList: true });
  }

  fetchCartForUpsell();
  } catch(e) { console.error(e); }
})();

})();
